<template>
  <div id="work-order" class="work-order"></div>
</template>

<script>
export default {
  name: 'workOrder',
  computed: {
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    userId() {
      return this.$store.state.baseData.userInfo.id;
    },
  },
  data() {
    return {

    };
  },
  mounted() {
    if (!this.isLogin) {
      this.$router.push('/login');
    } else {
      this.init();
    }
  },
  methods: {
    init() {
      // let token = new Date();
      // token = `${token.getFullYear()}${token.getMonth()}${token.getDate()}${Math.floor(Math.random(4) * 10000)}`;
      //
      // // 加载js
      // const scriptDom = document.createElement('script');
      // scriptDom.src = `https://assets-cli.s5.udesk.cn/ticket_sdk/ticket_sdk.js?t=${token}`;
      // document.body.appendChild(scriptDom);
      //
      // // 加载css
      // const styleDom = document.createElement('link');
      // styleDom.rel = 'stylesheet';
      // styleDom.href = `https://assets-cli.s5.udesk.cn/ticket_sdk/ticket_sdk.css?t=${token}`;
      // document.body.appendChild(styleDom);
      //
      // scriptDom.addEventListener('load', () => {
      //   this.getSign();
      // }, false);

      // 把script和css放到index.html文件头里，减少加载时间
      this.getSign();
    },

    initForm(data) {
      const map = { en_US: 'EN-US', zh_CN: 'ZH-CN' };
      const locale = localStorage.getItem('locale') || 'en_US';
      const params = {
        // [Required] Must provide subdomain.
        subdomain: '1951672.s5.udesk.cn',
        // [Required] Must provide client appId.
        appid: 'be77639cb64d473d',
        // [Required] Must provide signature.
        signature: data.signature,
        // [Required] Must provide type.
        type: data.type,
        // [Required] Must provide content.
        content: data.content,
        lang: map[locale], // ZH-CN/EN-US
      };

      const udesk = window.UdeskSDK.ticketSDK.init(params);

      udesk.create({
        type: 'new',
        // type: 'list',
        mode: 'web',
        classNames: 'subdomain-ticket-sdk',
        container: 'work-order', // 容器id值
        // height: '100%',
        width: '100%',
        // position: {
        //   position: 'relative',
        // },
      });
    },

    getSign() {
      this.axios({
        url: this.$store.state.url.workOrder.sign,
        params: { content: this.userId, type: 'token' },
        // params: { content: 'customer_token', type: 'token' },
        method: 'post',
      }).then(({ code, data, msg }) => {
        if (code === '0' && data) {
          this.initForm(data);
        } else {
          this.$bus.$emit('tip', { text: msg, type: 'error' });
        }
      }).catch(() => {
        this.$bus.$emit('tip', { text: this.$t('contract.c_error'), type: 'error' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/assets/css/global.scss';

  .work-order {
    min-height: 200px;

    ::v-deep .create-ticket__main {
      padding-bottom: 80px;
    }
  }
</style>
